export default __webpack_public_path__ + "static/media/Algemene-Voorwaarden-DashBee.38209331.pdf";